<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-2"> </p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-1">Also by Jim Harrison</span></p>
<p class="BT1stpara ParaOverride-2"><span class="CharOverride-2">FICTION</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Wolf: A False Memoir</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">A Good Day to Die </span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Farmer</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Warlock</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Sundog</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Dalva</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Woman Lit by Fireflies</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Julip</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Road Home</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Beast God Forgot to Invent</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">True North</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Summer He Didn’t Die</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Returning to Earth</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The English Major</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Farmer’s Daughter</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Great Leader</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The River Swimmer</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Brown Dog</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Big Seven</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Ancient Minstrel</span></p>
<p class="BT1stpara ParaOverride-2"><span class="CharOverride-2">CHILDREN’S LITERATURE</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Boy Who Ran to the Woods</span></p>
<p class="BT1stpara ParaOverride-2"><span class="CharOverride-2">POETRY</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Plain Song</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Locations</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Outlyer and Ghazals</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Letters to Yesenin</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Returning to Earth</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Selected &amp; New Poems: 1961–1981</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Theory and Practice of Rivers and New Poems</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">After Ikky</span><span class="CharOverride-4">ū</span><span class="CharOverride-3"> and Other Poems</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">The Shape of the Journey: New and Collected Poems</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Braided Creek: A Conversation in Poetry,</span><span class="CharOverride-5"> with Ted Kooser</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Saving Daylight</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">In Search of Small Gods</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Songs of Unreason</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Dead Man’s Float</span></p>
<p class="BT1stpara ParaOverride-2"><span class="CharOverride-2">ESSAYS</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Just Before Dark: Collected Nonfiction</span></p>
<p class="BT1stpara ParaOverride-2"><span class="CharOverride-2">MEMOIR</span></p>
<p class="BT1stpara ParaOverride-1"><span class="CharOverride-3">Off to the Side</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// V4481_eBook1.vue?0392dbc7